module.exports = __webpack_public_path__ + "media/images/sprite/ico-twitter@2x-bf442f87a539fde4b78d66e403e39e96.png";